import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=d15db4d4&scoped=true&"
import script from "./GameList.vue?vue&type=script&lang=js&"
export * from "./GameList.vue?vue&type=script&lang=js&"
import style0 from "./GameList.vue?vue&type=style&index=0&id=d15db4d4&scoped=true&lang=css&"
import style1 from "./GameList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15db4d4",
  null
  
)

export default component.exports